import React, { Component } from "react";
import "../../App.css";
import { getIndexObservers, updateIndexObserver } from "../../Api/Http";
import indexObserverConfig from "../../config/indexObserver.json";
import defaultConfig from "../../config/default.json";
import { sort, executeFunction } from "../../Utils/utils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const toNumber = value => (value === null || value === undefined ? null : parseFloat(value, 10));

// Distance of bearPrice below close, same formula as Triggers' Percent column.
const getPercent = ({ close, bearPrice }) =>
    close && bearPrice ? parseFloat((((close - bearPrice) / close) * 100).toFixed(2), 10) : null;

class IndexObserver extends Component {
    async componentDidMount() {
        const mapIndexObserver = value => {
            return {
                indexName: value.indexName,
                bearDistanceInPercent: toNumber(value.bearDistanceInPercent),
                bearResetPercent: toNumber(value.bearResetPercent),
                bearPrice: toNumber(value.bearPrice),
                bearConsecutiveHit: value.bearConsecutiveHit,
                close: toNumber(value.close),
                changePercent: toNumber(value.changePercent),
                updatedAt: value.updatedAt,
                history: value.history || [],
                percent: getPercent({ close: toNumber(value.close), bearPrice: toNumber(value.bearPrice) }),
                data: value,
            };
        };

        const getMappedIndexObservers = async () => {
            const getIndexObserversResp = await getIndexObservers();
            const resp = getIndexObserversResp.map(mapIndexObserver);
            this.setState({ getMappedIndexObserversResp: resp });
            this.setState({ indexObserversCount: resp.length });
            return resp;
        };

        let getMappedIndexObserversResp = await getMappedIndexObservers();

        const onClickOfUpdateIndexObserver = async ({ value }) => {
            const { data } = value;
            const body = { indexName: data.indexName };
            let shouldMakeCall = false;
            for (const key in this.state.updatedValues[data.indexName]) {
                if (this.state.updatedValues[data.indexName][key] !== undefined) {
                    if (value[key] !== this.state.updatedValues[data.indexName][key]) {
                        shouldMakeCall = true;
                        body[key] = this.state.updatedValues[data.indexName][key];
                    }
                }
            }
            if (shouldMakeCall) {
                const resp = await executeFunction({ reference: updateIndexObserver, body });
                if (resp && resp.indexName) {
                    const updatedValues = this.state.updatedValues;
                    delete updatedValues[data.indexName];
                    getMappedIndexObserversResp = this.state.getMappedIndexObserversResp.map(indexObserver =>
                        indexObserver.indexName === resp.indexName ? mapIndexObserver(resp) : indexObserver,
                    );
                    this.setState({
                        updatedValues: updatedValues,
                        getMappedIndexObserversResp: getMappedIndexObserversResp,
                    });
                }
            }
        };

        const ordering = async ({ key, type }) => {
            if (type === defaultConfig.order.type.ascending) {
                this.state.visibility[key][defaultConfig.order.type.descending] = true;
                getMappedIndexObserversResp = sort({
                    data: this.state.getMappedIndexObserversResp,
                    key,
                    type,
                });
            }
            if (type === defaultConfig.order.type.descending) {
                this.state.visibility[key][defaultConfig.order.type.ascending] = true;
                getMappedIndexObserversResp = sort({
                    data: this.state.getMappedIndexObserversResp,
                    key,
                    type,
                });
            }
            this.state.visibility[key][type] = !this.state.visibility[key][type];
            this.setState({ getMappedIndexObserversResp: getMappedIndexObserversResp });
            this.setState({ visibility: this.state.visibility });
        };

        const setDefaultVisibilityOfColumns = () => {
            const obj = {};
            for (const iterator of Object.keys(indexObserverConfig.page.columns)) {
                if (!obj[iterator]) {
                    obj[iterator] = {};
                }
                for (const orderIterator of Object.keys(defaultConfig.order.type)) {
                    if (defaultConfig.order.type.ascending === orderIterator) {
                        obj[iterator][orderIterator] = true;
                    } else {
                        obj[iterator][orderIterator] = false;
                    }
                }
            }
            return obj;
        };

        this.setState({ order: ordering });
        this.setState({ onClickOfUpdateIndexObserver: onClickOfUpdateIndexObserver });
        this.setState({ updatedValues: {} });
        this.setState({ visibility: setDefaultVisibilityOfColumns() });
    }

    setUpdatedValue({ value, key, newValue }) {
        const updatedValues = this.state.updatedValues;
        if (updatedValues) {
            if (!updatedValues[value.indexName]) {
                updatedValues[value.indexName] = {};
            }
            updatedValues[value.indexName][key] = newValue;
            this.setState({
                updatedValues: updatedValues,
            });
        }
    }

    toggleExpanded = indexName => {
        this.setState(prev => ({ expanded: prev.expanded === indexName ? null : indexName }));
    };

    renderHistory({ value }) {
        const history = value.history;
        if (!history.length) {
            return <span>No history yet</span>;
        }
        return (
            <div className="index-observer-history">
                <table>
                    <tr>
                        {[
                            "Action",
                            "Bear Dist %",
                            "Bear Reset %",
                            "Bear Price",
                            "Cons Hit",
                            "Close",
                            "Dy Change %",
                            "Date",
                        ].map(heading => (
                            <th className="triggers-table-columns-heading" key={heading}>
                                {heading}
                            </th>
                        ))}
                    </tr>
                    {history.map(entry => (
                        <tr key={entry.date + entry.action}>
                            <td className="triggers-table-rows">{entry.action}</td>
                            <td className="triggers-table-rows">{entry.bearDistanceInPercent}</td>
                            <td className="triggers-table-rows">{entry.bearResetPercent}</td>
                            <td className="triggers-table-rows">{entry.previousBearPrice}</td>
                            <td className="triggers-table-rows">{entry.bearConsecutiveHit}</td>
                            <td className="triggers-table-rows">{entry.close}</td>
                            <td
                                className={`triggers-table-rows ${
                                    entry.changePercent < 0
                                        ? "value-negative"
                                        : entry.changePercent > 0
                                          ? "value-positive"
                                          : ""
                                }`}
                            >
                                {entry.changePercent !== null && entry.changePercent !== undefined
                                    ? `${entry.changePercent}%`
                                    : "-"}
                            </td>
                            <td className="triggers-table-rows">{entry.date || "-"}</td>
                        </tr>
                    ))}
                </table>
            </div>
        );
    }

    renderEditablePercent({ value, key }) {
        return (
            <Popup
                key={value.indexName + "_" + key + "_popup"}
                closeOnDocumentClick
                disabled={false}
                trigger={<button> {value[key] !== null ? value[key] : "-"} </button>}
                position="center center"
            >
                <div>
                    <input
                        key={value.indexName + "_" + key + "_input"}
                        className="target-input-box"
                        type="text"
                        defaultValue={value[key] !== null ? value[key] : ""}
                        onChange={event => {
                            if (event && event.target && event.target.value) {
                                this.setUpdatedValue({
                                    value,
                                    key,
                                    newValue: Math.max(parseFloat(event.target.value) || 0, 0),
                                });
                            }
                            return;
                        }}
                    />
                </div>
                <span>
                    {<button onClick={() => this.state.onClickOfUpdateIndexObserver({ value })}>&#x2714;</button>}
                </span>
            </Popup>
        );
    }

    render() {
        let getMappedIndexObserversResp;
        if (this.state && this.state.getMappedIndexObserversResp) {
            //headers
            getMappedIndexObserversResp = [
                <div>
                    <tr>
                        {Object.keys(indexObserverConfig.page.columns).map(value => (
                            <th className="triggers-table-columns-heading">
                                {indexObserverConfig.page.columns[value].name}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["ascending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.order({
                                                    key: value,
                                                    type: defaultConfig.order.type.ascending,
                                                })
                                            }
                                        >
                                            &#9650;
                                        </button>
                                    )}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["descending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.order({
                                                    key: value,
                                                    type: defaultConfig.order.type.descending,
                                                })
                                            }
                                        >
                                            &#9660;
                                        </button>
                                    )}
                            </th>
                        ))}
                    </tr>
                </div>,
            ];
            //data
            getMappedIndexObserversResp.push(
                ...this.state.getMappedIndexObserversResp.map(value => (
                    <div id={value.indexName}>
                        <tr>
                            <td className="triggers-table-rows">
                                <span>{value.indexName}</span>
                            </td>
                            <td className="triggers-table-rows">
                                {this.renderEditablePercent({ value, key: "bearDistanceInPercent" })}
                            </td>
                            <td className="triggers-table-rows">
                                {this.renderEditablePercent({ value, key: "bearResetPercent" })}
                            </td>
                            <td className="triggers-table-rows">{value.bearPrice !== null ? value.bearPrice : "-"}</td>
                            <td className="triggers-table-rows">{value.bearConsecutiveHit}</td>
                            <td className="triggers-table-rows">{value.close !== null ? value.close : "-"}</td>
                            <td className="triggers-table-rows">
                                {value.changePercent !== null ? `${value.changePercent}%` : "-"}
                            </td>
                            <td className="triggers-table-rows">{value.updatedAt || "-"}</td>
                            <td className="triggers-table-rows">
                                <button onClick={() => this.toggleExpanded(value.indexName)}>
                                    {`${this.state.expanded === value.indexName ? "\u25B2 Hide" : "\u25BC View"} (${
                                        value.history.length
                                    })`}
                                </button>
                            </td>
                            <td className="triggers-table-rows">
                                {value.percent !== null ? `${value.percent}%` : "-"}
                            </td>
                        </tr>
                        {this.state.expanded === value.indexName && (
                            <tr>
                                <td
                                    className="triggers-table-rows"
                                    colSpan={Object.keys(indexObserverConfig.page.columns).length}
                                >
                                    {this.renderHistory({ value })}
                                </td>
                            </tr>
                        )}
                    </div>
                )),
            );
        }
        return (
            <div>
                <div>
                    <header className="header-with-tagline">
                        <h1>Indices ({(this.state && this.state.indexObserversCount) || 0})</h1>
                        <span className="market-header-tagline">
                            Want a notification when any index falls? Contact{" "}
                            <a href="mailto:sindhuanurag2@gmail.com">sindhuanurag2@gmail.com</a>
                        </span>
                    </header>
                </div>
                <div>
                    <header className="triggers-table">
                        <table>{getMappedIndexObserversResp}</table>
                    </header>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default IndexObserver;
